import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { FiPhone, FiMail, FiMapPin, FiFacebook, FiTwitter, FiInstagram, FiLinkedin } from 'react-icons/fi';

const FooterContainer = styled.footer`
  background: ${props => props.theme.colors.primary};
  color: ${props => props.theme.colors.white};
  padding: 60px 0 20px;
`;

const FooterContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 40px;
  
  @media (max-width: ${props => props.theme.breakpoints.tablet}) {
    grid-template-columns: repeat(2, 1fr);
  }
  
  @media (max-width: ${props => props.theme.breakpoints.mobile}) {
    grid-template-columns: 1fr;
  }
`;

const FooterSection = styled.div`
  h3 {
    color: ${props => props.theme.colors.white};
    margin-bottom: 20px;
    font-size: 1.2rem;
  }
  
  p {
    margin-bottom: 10px;
    line-height: 1.6;
    color: ${props => props.theme.colors.white};
  }
  
  ul {
    list-style: none;
    padding: 0;
  }
  
  li {
    margin-bottom: 8px;
  }
  
  a {
    color: ${props => props.theme.colors.white};
    text-decoration: none;
    transition: color 0.3s ease;
    
    &:hover {
      color: ${props => props.theme.colors.secondary};
    }
  }
`;

const LogoSection = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  
  img {
    height: 60px;
    width: auto;
  }
`;

const ContactItem = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 15px;
  color: ${props => props.theme.colors.white};
  
  svg {
    color: ${props => props.theme.colors.white};
    flex-shrink: 0;
  }
  
  div {
    color: ${props => props.theme.colors.white};
    
    div {
      color: ${props => props.theme.colors.white};
    }
  }
`;

const SocialLinks = styled.div`
  display: flex;
  gap: 15px;
  margin-top: 20px;
  
  button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    background: ${props => props.theme.colors.secondary};
    border-radius: 50%;
    transition: all 0.3s ease;
    border: none;
    cursor: pointer;
    color: ${props => props.theme.colors.white};
    
    &:hover {
      background: ${props => props.theme.colors.white};
      color: ${props => props.theme.colors.secondary};
      transform: translateY(-2px);
    }
  }
`;

const BottomBar = styled.div`
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  margin-top: 40px;
  padding-top: 20px;
  text-align: center;
  
  p {
    margin: 0;
    color: rgba(255, 255, 255, 0.8);
  }
`;

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <FooterContainer>
      <FooterContent>
        <FooterSection>
          <LogoSection>
            <img src="/logo-simple.svg" alt="Trimurthy Tent House" />
          </LogoSection>
          <p>
            A trusted 36-year old Tent House Dealer and Tent House Supplier in Bangalore. 
            We provide premium tent solutions for all your events and celebrations.
          </p>
          <SocialLinks>
            <button type="button" aria-label="Facebook">
              <FiFacebook />
            </button>
            <button type="button" aria-label="Twitter">
              <FiTwitter />
            </button>
            <button type="button" aria-label="Instagram">
              <FiInstagram />
            </button>
            <button type="button" aria-label="LinkedIn">
              <FiLinkedin />
            </button>
          </SocialLinks>
        </FooterSection>

        <FooterSection>
          <h3>Quick Links</h3>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/about">About Us</Link></li>
            <li><Link to="/services">Services</Link></li>
            <li><Link to="/what-we-do">What We Do</Link></li>
            <li><Link to="/gallery">Gallery</Link></li>
            <li><Link to="/contact">Contact Us</Link></li>
          </ul>
        </FooterSection>

        <FooterSection>
          <h3>Our Services</h3>
          <ul>
            <li><Link to="/services">German Hangers</Link></li>
            <li><Link to="/services">Barricading</Link></li>
            <li><Link to="/services">Arabian Tents</Link></li>
            <li><Link to="/services">Stages & Platforms</Link></li>
            <li><Link to="/services">Backdrops</Link></li>
            <li><Link to="/services">German Sheds</Link></li>
            <li><Link to="/services">Event Management</Link></li>
            <li><Link to="/services">Furniture Rental</Link></li>
            <li><Link to="/services">Shamiyanas Rental</Link></li>
            <li><Link to="/services">Tables Rental</Link></li>
            <li><Link to="/services">Carpets</Link></li>
          </ul>
        </FooterSection>

        <FooterSection>
          <h3>Contact Info</h3>
          <ContactItem>
            <FiPhone />
            <div>
              <div>8880828698</div>
              
            </div>
          </ContactItem>
          <ContactItem>
            <FiMail />
            <div>
             
              <div>suryakiran1321@gmail.com</div>
            </div>
          </ContactItem>
          <ContactItem>
            <FiMapPin />
            <div>
              <div>Corporate Address:</div>
              <div>80feet, Omkar Hills Rd,Sri Krishna Garden Layout,Rajarajeshwari Nagar,Bengaluru, Karnataka 560059</div>
            </div>
          </ContactItem>
        </FooterSection>
      </FooterContent>

      <BottomBar>
        <p>&copy; {currentYear} Trimurthy Tent House. All rights reserved. Designed & Developed by<Link href="https://www.nakshatranamahacreations.com/"> Nakshatra Namaha Creations</Link></p>
      </BottomBar>
    </FooterContainer>
  );
};

export default Footer; 